import { useState, useEffect } from "react";
import * as S from "./styles.js";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers/AssetsHelpers.js";

const DEFAULT_TITLE = "Estamos ativando sua conta";
const DEFAULT_SUBTITLE =
  "Em instantes, você terá acesso à Jusfy, a plataforma que facilita a sua vida jurídica.";

// `title`/`subtitle` opcionais: o checkout de infoprodutor (CadastroV2 com cupom
// LAWLETTER etc.) não cria conta na Jusfy, então a copy padrão mentiria ali.
export const ModalProcessingPaymentContent = ({
  isOpen,
  title = DEFAULT_TITLE,
  subtitle = DEFAULT_SUBTITLE,
}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!isOpen) {
      setProgress(0);
      return;
    }

    const duration = 1 * 60 * 1000;
    const interval = 100;
    const increment = (100 / duration) * interval;

    const timer = setInterval(() => {
      setProgress(prev => {
        const next = prev + increment;
        if (next >= 100) {
          return 0;
        }
        return next;
      });
    }, interval);

    return () => clearInterval(timer);
  }, [isOpen]);

  return (
    <S.ContentModal>
      <S.TextContent>
        <SVG src={toAbsoluteUrl("/media/checkout/waiting.svg")} />
        <S.Title>{title}</S.Title>
        <S.SubTitle>{subtitle}</S.SubTitle>
      </S.TextContent>
      <S.ProgressBarContainer>
        <S.ProgressBarFill progress={progress} />
      </S.ProgressBarContainer>
    </S.ContentModal>
  );
};

export const ModalProcessingPayment = props => {
  return (
    <S.ModalWrapper open={props.isOpen} onClose={props.onClose}>
      <ModalProcessingPaymentContent isOpen={props.isOpen} {...props} />
    </S.ModalWrapper>
  );
};
